import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {CreateKycMultiFormStepWrapper} from "../../create-kyc/multi-step/wrapper";
import {useGetKycStatusContext} from "../context/get-kyc-status";
import {KycVerificationView} from "../verifcation-view";
import {Button} from "antd";

export function KycPageView() {
  const {state} = useGetKycStatusContext();
  const {state: profileState} = useGetProfileContext();

  // if (state.isLoadingKycStatus) {
  //   return <FullPageLoader />;
  // }
  function handleTryAgain() {
    state.setKycStatusOverride(true);
    // dispatch({type: "RESET_FORM"});
  }

  console.log({state});
  const effectiveStatus = profileState.profileData.isKyc_verified
    ? "successful"
    : state.kycStatusOverride
    ? "no_entry"
    : state.kycStatus;
  console.log({effectiveStatus});

  function handleView() {
    let content;
    switch (effectiveStatus) {
      case "pending":
        content = (
          <KycVerificationView
            description="Thanks for submitting your details. Our team is currently reviewing your documents to verify your identity. This usually takes 24–48 hours. You’ll get an email notification once your account is verified."
            title="Verification in progress"
            videoSrc="KYC pending"
          />
        );
        break;
      case "rejected":
        content = (
          <KycVerificationView
            description={
              <span>
                <span style={{display: "block"}}>
                  Unfortunately, we couldn't verify your account with the submitted
                  information. This may be due to unclear documents or missing details.
                </span>
                {state.kycStatusData?.data.reasonForRejection ? (
                  <span style={{display: "block"}}>
                    <b>Reason: {state.kycStatusData?.data.reasonForRejection}.</b>
                  </span>
                ) : (
                  ""
                )}
                <span style={{display: "block"}}>
                  Please review your submission and{" "}
                  <Button
                    type="text"
                    style={{
                      padding: 0,
                      height: "auto",
                    }}
                    onClick={handleTryAgain}
                  >
                    <span style={{fontWeight: 600, textDecoration: "underline"}}>
                      try again
                    </span>
                  </Button>
                </span>
              </span>
            }
            title="Verification unsuccessful"
            videoSrc="KYC failed"
          />
        );
        break;
      case "successful":
        content = (
          <KycVerificationView
            description="Congratulations! Your identity has been successfully verified and your account is now secure and compliant."
            title="Verification successful"
            videoSrc="KYC successful"
          />
        );
        break;
      default:
      case "no_entry":
        content = <CreateKycMultiFormStepWrapper />;
    }
    return content;
  }
  return <div>{handleView()}</div>;
}
